import { styled, TextField } from '@mui/material';

export const StyledField = styled(TextField)({
  '& input': {
    padding: 10,
  },
});
